import React, { Component } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import {isEdge} from '../../utils/brower';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
	button: {
		margin: theme.spacing.unit,
		display:'inline-block',
		color:"#FFFFFF"
	},

	closeIcon:{
		position:'absolute',
		top:10,
		right:10
	},
	cautionCloseIcon:{
		position:'absolute',
		top:0,
		right:0
	},
	cautionButton: {
		margin: 0,
		display:'inline-block',
		color:"#000000"
	},
	pdfUnabale:{
		textAlign:'center',
		color:'#FFFFFF',
		position:'absolute',
		top:'50%',
		left:0,
		width:'100%'

	}
});

class pdfViewer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isClose:false
		}
	}

	handleClose = () => {
		if(this.props.afterCloseFunc) this.props.afterCloseFunc();
	};

	handleOpenPdf = () =>{
		window.open(this.props.filePath);
	};
	handleCloseCautions = () =>{
		this.setState({isClose:true})
	};
	
	
	render() {
		const {classes,filePath} = this.props;
		const height = (this.props.navigation.windowHeight * 0.95);
		const width = (this.props.navigation.windowWidth * 0.9) - 60;

		const isClose = this.state.isClose;

		return (
			
			<div className="over_rays">
				<div className={classes.closeIcon}>
					<IconButton color={"primary"} className={classes.button} aria-label="CLOSE"
								onClick={this.handleClose}>
						<CloseIcon/>
					</IconButton>
				</div>
				
				<div className="pdf_inner">
					{filePath ?
						<embed
							src={filePath}
							width={width}
							height={height}
						/>
						:
						<div style={{width,height,position:'relative'}}>
							<span className={classes.pdfUnabale}>現在このPDFファイルは利用できません</span>
						</div>
					}
				</div>
				{isEdge() &&
				<div className={classNames("edge_cautions",{"is_closed":isClose})}>
					<div className={classes.cautionCloseIcon}>
						<IconButton color={"primary"} className={classes.cautionButton} aria-label="CLOSE"
									onClick={this.handleCloseCautions}>
							<CloseIcon/>
						</IconButton>
					</div>
					<div className="cautions_title">microsoft edgeをご利用の方</div>
					<p className="cautions_text">
						表示されているPDFを右クリックし、<br/>
						メニューから「印刷」を選択し印刷して下さい
					</p>
					<p className="cautions_links">
						<span onClick={this.handleOpenPdf}>「印刷」が表示されない方</span>
					</p>
				</div>
				}
			</div>
		);
	}
}
pdfViewer.propTypes = {
	filePath:PropTypes.string,
	afterCloseFunc:PropTypes.func
};
pdfViewer.defaultProps = {
	filePath:''
};
function mapStateToProps(state) {
	return {
		navigation : state.navigation
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(pdfViewer);


// WEBPACK FOOTER //
// ./src/common/components/viewer/pdf-viewer.js